<template>
  <div>
    <img
      src="https://www.yokogawa.com/public/img/iphone4_retina_114x114.png"
      width="40"
      height="40"
      alt="Yokogawa Logo"
      title="Yokogawa Logo"
    >
  </div>
</template>

<script>
export default {
  name: 'YokogawaLogo',
}
</script>
